import { createContext, useContext } from 'react';
import type { RevealApi } from 'reveal.js';

interface PresentationContextType {
  deck: RevealApi | null;
  isInitialized: boolean;
}

export const PresentationContext = createContext<PresentationContextType>({
  deck: null,
  isInitialized: false,
});

export const usePresentationContext = () => {
  const context = useContext(PresentationContext);
  if (!context) {
    throw new Error('usePresentationContext must be used within a PresentationContext.Provider');
  }
  return context;
};
